import type { JSX } from "react";
export interface Source {
  label: string;
  prop: string;
  icon?: JSX.Element;
  allowKeywords?: boolean;
}

export const defaultSources: Source[] = [
  {
    label: 'Insights',
    prop: 'insight',
  },
  {
    label: 'Signals',
    prop: 'signal',
  },
  {
    label: 'Entities',
    prop: 'entity',
  },
];

export const recordSources: Source[] = [
  {
    label: 'Records',
    prop: 'record',
    allowKeywords: true,
  },
];
